import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import highTechnologyImg from "../../../../assets/imgs/services/nationals/high-technology.jpg";
import Accordion from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";

import highTech1Icon from "../../../../assets/imgs/services/nationals/hightech-icons/hightech1.svg"
import highTech2Icon from "../../../../assets/imgs/services/nationals/hightech-icons/hightech2.svg"
import highTech3Icon from "../../../../assets/imgs/services/nationals/gold-icons/Condiciones02.svg"
import highTech5Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier1.svg"
import highTech6Icon from "../../../../assets/imgs/services/nationals/highvalue-icons/highvalue3.svg"
import NationalDescription from "../../../../components/national-description/national-description";

function HighTechnology() {
  const [tHighTechnology] = useTranslation("highTechnologyPage");
  const [tSMetaData] = useTranslation("metaData");
  const idHighTechnology = "657ae65a-eb11-4666-b84d-3b3e1e953590";
  const [textDescription, setTextDescription] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [openAccordion, setOpenAccordion] = useState(null);

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[5]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[5]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idHighTechnology}`)
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion2(
            response.data.textWeb.text_us["03-Check-in, Acceptance and Pickup"]
              .content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("altaTecnología.title")}</title>
        <meta
          name="description"
          content={tSMetaData("altaTecnología.description")}
        />
      </Helmet>
      {/* <ImageHeader
        section={tHighTechnology("header.section")}
        title={tHighTechnology("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tHighTechnology("description.content"))
        }
        quoteBtn={tHighTechnology("header.quote-btn")}
        quoteProductID="btnQuoteTech"
        contactSales={tHighTechnology("header.contact-sales")}
        contactProductID="btnContactTech"
        imgBackground={highTechnologyImg}
      /> */}
      <ImageHeader
        imgBackground={highTechnologyImg}
      />

      {/* <Accordion
        title={tHighTechnology("accordion-1.title")}
        content={JSON.parse(tHighTechnology("accordion-1.content"))}
      />
      <div className="divider"></div>
      <Accordion
        title={tHighTechnology("accordion-2.title")}
        content={
          accordion2
            ? JSON.parse(accordion2)
            : JSON.parse(tHighTechnology("accordion-2.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tHighTechnology("accordion-3.title")}
        content={JSON.parse(tHighTechnology("accordion-3.content"))}
      /> */}
      <div className="info-national-content">
        <NationalDescription
          title={tHighTechnology("header.title")} 
          description={
            textDescription
            ? JSON.parse(textDescription) : ""
          }
          quoteBtn={tHighTechnology("header.quote-btn")}
          quoteProductID="btnQuoteGold"
          contactSales={tHighTechnology("header.contact-sales")}
          contactProductID="btnContactGold"
        />
        <div className="accordion-content-main">
          <div className="title">
            <h3>{tHighTechnology("header.prepare-charge")}</h3>
          </div>

          <div className="accordion-padd">
            <Accordion
              id={1}
              isOpen={openAccordion === 1}
              onToggle={setOpenAccordion}
              title={tHighTechnology("accordion-1.title")}
              content={
                tHighTechnology("accordion-1.content")
                  ? JSON.parse(tHighTechnology("accordion-1.content")) : "{}"
              }
            />

            <Accordion
              id={2}
              isOpen={openAccordion === 2}
              onToggle={setOpenAccordion}
              title={tHighTechnology("accordion-2.title")}
              content={
                accordion2
                  ? JSON.parse(accordion2) : "{}"
              }
            />

            <Accordion
              id={3}
              isOpen={openAccordion === 3}
              onToggle={setOpenAccordion}
              title={tHighTechnology("accordion-3.title")}
              content={
                tHighTechnology("accordion-3.content")
                  ? JSON.parse(tHighTechnology("accordion-3.content")) : "{}"
              }
            />
          </div>
          
        </div>
      </div>

      {/* ===================================================== */}

      <div className="more-info-content">
        <div className="more-info-box">
          <h5>{tHighTechnology("non-applicable-charges.title")}</h5>

          <div className="icons">
            <div className="item">
              <div className="icon"><img src={highTech1Icon} /></div>
              <p>{tHighTechnology("non-applicable-charges.item1")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={highTech2Icon} /></div>
              <p>{tHighTechnology("non-applicable-charges.item2")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={highTech3Icon} /></div>
              <p>{tHighTechnology("non-applicable-charges.item3")}</p>
            </div>

          </div>
        </div>

        <div className="more-info-box">
          <h5>{tHighTechnology("additional-conditions.title")}</h5>

          <div className="icons">
            <div className="item">
              <div className="icon"><img src={highTech3Icon} /></div>
              <p>{tHighTechnology("additional-conditions.item1")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={highTech5Icon} /></div>
              <p>{tHighTechnology("additional-conditions.item2")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={highTech6Icon} /></div>
              <p>{tHighTechnology("additional-conditions.item3")}</p>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default HighTechnology;
